import React, {useState} from 'react';
import './App.css';
import Header from './components/Header';
import Carousel from './components/Carousel';
import Navigation from './components/Navigation';
import CookiesMessage from './components/CookiesMessage';
import DemoInfo from './components/DemoInfo';
import Presentation from './components/Presentation';
import Gallery from './components/Gallery';
import Booking from './components/bookingComponents/Booking';
import Tours from './components/Tours';
import Comments from './components/Comments';
import Footer from './components/Footer';

function App() {
  const [menu, setMenu] = useState('');
  const [mode, setMode] = useState('user');
  const [demoInfoDisplay, setDemoInfoDisplay] = useState(true);
  const [cookiesDisplay, setCookiesDisplay] = useState(true);
  
  return (
    <div className="App" style={{overflow: menu === '' ? 'hidden' : 'auto'}}>
      <Header menu={menu} setMenu={setMenu} />
      <Navigation menu={menu} setMenu={setMenu} />
      {demoInfoDisplay && (
        <DemoInfo
          setDemoInfoDisplay={setDemoInfoDisplay} />
      )}
      {!demoInfoDisplay && cookiesDisplay && (
        <CookiesMessage
          setCookiesDisplay={setCookiesDisplay} />
      )}
      {menu === '' && <Carousel />}
      {menu === 'Presentation' && <Presentation menu={menu} setMenu={setMenu} mode={mode}/>}
      {menu === 'Gallery' && <Gallery menu={menu} setMenu={setMenu} />}
      {menu === 'Booking' && <Booking menu={menu} setMenu={setMenu} />}
      {menu === 'Tours' && <Tours menu={menu} setMenu={setMenu} />}
      {menu === 'Comments' && <Comments menu={menu} setMenu={setMenu} />}
      {!cookiesDisplay && !demoInfoDisplay && (
        <Footer />
      )}
    </div>
  );
}

export default App;
